import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import Notification from "../../../elements/notification/Notification";
import MasterRefillingsDetailsContent from "./MasterRefillingsDetailsContent";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledMasterRefillingsDetailsWrapper } from "../../styledMasterRefillings";

const MasterRefillingsDetailsContainer = ({ match }) => {
  const { t } = useTranslation("masterRefillingsPage");
  const history = useHistory();
  const [refilling, setRefilling] = useState(null);
  const [fetch, setFetch] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchRefillings = () => {
    axios.get("/api/master-refillings/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setRefilling(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchRefillings();
  }, [fetch]);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledMasterRefillingsDetailsWrapper>
          <div className="refiling-details-head">
            <GoToBackButton
              handler={() => {history.goBack();}}
            />
          </div>
          <MasterRefillingsDetailsContent
            t={t}
            refilling={refilling}
            setNotification={setNotification}
          />
        </StyledMasterRefillingsDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default MasterRefillingsDetailsContainer;